<template>
    <div>
        <b-form @submit.prevent="onSubmit">
            <b-row class="mt-3">    
                <b-col cols="12" class="d-flex justify-content-end">
                    <b-button variant="primary" @click="showEmpenhoFinder">
                        +
                    </b-button>
                    <LgFinderPageEmpenho :prefix="[prefix]" ref="empenhoFinder"  @input="addEmpenho"
                        style="display: none;" />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-table small :items="contratoForm.empenhos" :fields="empenhosFields" responsive>
                        <template #cell(actions)="data">
                            <b-button size="sm" variant="danger" @click="removeEmpenho(data.item)">
                                <b-icon icon="trash"></b-icon>

                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import LgFinderPageEmpenho from "@/components/Finders/LgFinderPageEmpenho.vue";

export default {
    name: "ContratoForm",
    components: {
        LgFinderPageEmpenho,
    },
    props: {
        id: {
            type: String,
            default: ''
        },

        prefix: {
            type: String,
            default: ""
        },
        contratoFormParam: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contratoForm: this.contratoFormParam,
            empenhosFields: [
                { key: 'numero', label: 'Número' },
                { key: 'descricao', label: 'Descrição' },
                { key: 'actions', label: 'Ações' },
            ],
        };
    },
    methods: {

        onSubmit() {
            this.contratoForm.empenhosIds = this.contratoForm.empenhos
                ? this.contratoForm.empenhos.map(c => c.id)
                : [];
            this.$emit("contratoFormSubmit", this.contratoForm);
        },
        showEmpenhoFinder() {
            this.$refs.empenhoFinder.show();
        },
        addEmpenho(item) {
            if (!item || !item.id)
                return;
            const empenho = {
                id: item.id,
                numero: item.numero,
                descricao: item.descricao,
            };

            if (!this.contratoForm.empenhos.some(c => c.id === empenho.id)) {
                this.contratoForm.empenhos.push(empenho);
            } else {
                this.$bvToast.toast('Empenho já adicionado', {
                    title: 'Atenção',
                    variant: 'warning',
                    solid: true,
                });
            }
        },
        removeEmpenho(item) {
            this.contratoForm.empenhos = this.contratoForm.empenhos.filter(c => c.id !== item.id);
        },
    },
};
</script>

<style scoped></style>
